import client from "../config/axios";

export const getDbaByGrade = async (grade) => {
  const response = await client.get(`/dba/by-grade/${grade}`);
  return response.data;
};


export const getknowledgearea = async (search) => {
  const response = await client.get(`/dba/knowledge_area`);
  return response.data;
};

export const getbygradearea = async (data) => {
  const response = await client.get(`/dba/by-grade-area`,{
    params: {
      grade: data.grade,
      area: data.area
    }
  });
  return response.data;
};

